import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Check } from 'lucide-react';
import { CatalogStatus, type FeatureValue } from '@/modules/service-purchase/types';
import { ServiceCatalogStatus } from '../service-catalog-status';
import { useServiceCatalogEnabled } from './service-catalog-context';
interface FeatureCellProps {
  value: FeatureValue;
  isActive: boolean;
}
function ServiceCatalogCell(t0) {
  const $ = _c(10);
  const {
    value,
    isActive
  } = t0;
  const isGroupEnabled = useServiceCatalogEnabled();
  if (typeof value === "boolean") {
    let t1;
    if ($[0] !== isGroupEnabled || $[1] !== value) {
      t1 = <div className="flex items-center justify-center">{value ? <Check className={cn("size-4", isGroupEnabled ? "text-status-success brightness-75" : "text-foreground/40")} /> : <span className="text-foreground/60">—</span>}</div>;
      $[0] = isGroupEnabled;
      $[1] = value;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (typeof value === "string" && Object.values(CatalogStatus).includes(value as CatalogStatus)) {
    const t1 = value as CatalogStatus;
    let t2;
    if ($[3] !== t1) {
      t2 = <div className="flex justify-center"><ServiceCatalogStatus catalogStatus={t1} /></div>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (typeof value === "string") {
    const t1 = isActive ? "text-foreground font-medium" : "text-foreground/70";
    let t2;
    if ($[5] !== t1) {
      t2 = cn("text-center text-sm", t1);
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t2 || $[8] !== value) {
      t3 = <span className={t2}>{value}</span>;
      $[7] = t2;
      $[8] = value;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  return null;
}
export { ServiceCatalogCell };